
import React from "react";
import { Text } from "../containers/language";

export const Leaven = () => {return (<p>
    <Text tid="leavinExp1" />
        <br />
    <Text tid="leavinExp2" />
        <br />
    <Text tid="leavinExp3" />
</p>);}

export const Hydration = () => {return (<p>
    <Text tid="hydrationExp1" />
</p>);}

export const Salt = () => {return (<p>
    <Text tid="saltExp1" />
</p>);}

export const Bulkproofing = () => {return (<p>
    <Text tid="bulkproofingExp1" /><br />
    <Text tid="bulkproofingExp2" />
</p>)}

export const Proofing = () => {return (<p>
    <Text tid="proofingExp1" />
    <br />
    <Text tid="proofingExp2" />
</p>)}
